import { useEffect } from 'react'
import { RelevantIDEntry, useRelevantIDsContext } from './RelevantIDsProvider'

/**
 * Registers an entry in the Cmd+I relevant IDs dialog for as long as the
 * calling component is mounted. Pass `null` when there's nothing to
 * register yet (e.g. no document loaded, no field selected).
 */
export default function useRegisterRelevantID(entry: RelevantIDEntry | null) {
  const { registerRelevantID, unregisterRelevantID } = useRelevantIDsContext()
  const { group, label, type, id, secondary, icon, color } = entry ?? {}

  useEffect(() => {
    if (!group || !label || !id) return

    registerRelevantID({ group, label, type, id, secondary, icon, color })
    return () => unregisterRelevantID(id)
  }, [
    group,
    label,
    type,
    id,
    secondary,
    icon,
    color,
    registerRelevantID,
    unregisterRelevantID,
  ])
}
